import config from "../../helpers/config.helper";

const appConfig = config();
const dateTimeFormat = appConfig.REACT_APP_DATE_TIME_FORMAT;

export type Options = {
    title: any;
    axisX: any,
    axisY: any,
    toolTip?: any,
    data: DataObj[],
    height: number,
    //width: number,
    backgroundColor?: string,
    theme?: string,
    zoomEnabled: boolean,
    interactivityEnabled: boolean,
    animationEnabled: boolean,
    exportEnabled: boolean,
    culture: string
}

export type Map<T> = {
    [id: number]: T;
}

export type DataPoint = { x: any, y?: any };

export type DataObj = {
    type: string;
    id: string;
    showInLegend?: boolean;
    name?: string;
    color?: string;
    lineThickness?: number;
    markerType?: string;
    markerColor?: string;
    markerBorderColor?: string;
    markerBorderThickness?: number;
    markerSize?: number;
    highlightEnabled?: boolean;
    xValueFormatString?: string;
    yValueFormatString?: string;
    dataPoints: Array<DataPoint>
}

/* ─── Default options — dark navy / cyan theme to match Image 1 ────────── */
export const initOptions: Options = {
    backgroundColor: "#0d1117",
    theme: "dark2",

    title: {
        text: "",
        fontSize: 16,
        fontFamily: "Segoe UI, Roboto, sans-serif",
        fontColor: "#ffffff",
        fontWeight: "bold",
    },

    toolTip: {
        backgroundColor: "#1e2a44",
        fontColor: "#ffffff",
        borderColor: "#00e5ff",
        borderThickness: 1,
        cornerRadius: 6,
        fontFamily: "Segoe UI, sans-serif",
        fontSize: 13,
        fontWeight: "bold",
        content: "<b>{x}</b><br/>{y}",
    },

    axisX: {
        title: "",
        valueFormatString: "DD-MMM",
        interval: 2,
        intervalType: "day",
        labelFontSize: 12,
        labelFontFamily: "Segoe UI, sans-serif",
        labelFontColor: "#e2e8f0",
        labelFontWeight: "bold",
        titleFontSize: 13,
        titleFontFamily: "Segoe UI, sans-serif",
        titleFontColor: "#e2e8f0",
        lineThickness: 1,
        lineColor: "rgba(255,255,255,0.25)",
        tickColor: "rgba(255,255,255,0.25)",
        tickThickness: 1,
        tickLength: 5,
        gridColor: "rgba(255,255,255,0.12)",
        gridThickness: 1,
        gridDashType: "solid",
    },

    axisY: {
        title: "Data",
        titleFontColor: "#e2e8f0",
        titleFontSize: 13,
        titleFontFamily: "Segoe UI, sans-serif",
        titleFontWeight: "bold",
        labelFontSize: 12,
        labelFontFamily: "Segoe UI, sans-serif",
        labelFontColor: "#e2e8f0",
        labelFontWeight: "bold",
        gridColor: "rgba(255,255,255,0.12)",
        gridThickness: 1,
        gridDashType: "solid",
        lineThickness: 1,
        lineColor: "rgba(255,255,255,0.25)",
        tickColor: "rgba(255,255,255,0.25)",
        tickThickness: 1,
        tickLength: 5,
    },

    height: 550,
    //width: 800,

    data: [
        {
            xValueFormatString: dateTimeFormat,
            type: "splineArea",                  // smooth curved line (was splineArea)
            id: "0_0",
            color: "#00e5ff",
            lineThickness: 2,
            markerType: "circle",
            markerColor: "#00e5ff",
            markerBorderColor: "#0d1117",
            markerBorderThickness: 1,
            markerSize: 6,
            highlightEnabled: true,          // auto-enlarges marker on hover
            dataPoints: [],
        },
    ],

    zoomEnabled: true,
    interactivityEnabled: true,
    animationEnabled: true,
    exportEnabled: true,                     // ← CanvasJS default toolbar
    culture: "en"
};
